module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-gladys.6f3c79f9.svg";